// Stable anonymous user id stored in localStorage. Used for voting + ownership
// of community-published sprites.
import { useEffect, useState } from 'react';

const ID_KEY = 'sprite_vault_user_id';
const NAME_KEY = 'sprite_vault_user_name';

function genId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `u-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function loadId() {
  try {
    let id = localStorage.getItem(ID_KEY);
    if (!id) {
      id = genId();
      localStorage.setItem(ID_KEY, id);
    }
    return id;
  } catch (e) {
    return genId();
  }
}

function loadName() {
  try {
    return localStorage.getItem(NAME_KEY) || '';
  } catch (e) {
    return '';
  }
}

export function useUserId() {
  const [userId] = useState(loadId);
  const [name, setNameState] = useState(loadName);

  useEffect(() => {
    try {
      if (name) localStorage.setItem(NAME_KEY, name);
    } catch (e) { /* ignore */ }
  }, [name]);

  const setName = (n) => setNameState((n || '').trim().slice(0, 24));

  return { userId, name, setName };
}
